import React from "react";
import SbuxRadioGroup from "../../../../../../components/SbuxRadioGroup";
import { Box, FormControlLabel, Radio } from "@mui/material";
import styles from "./styles";
import useCss from "../../../../../../hooks/useCss";

interface Props {
  dailyOption?: string;
  dailyOptoin1InputValue?: number;
  handleDailyOptionsValueChange?: (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => void;
  handleDailyOptoin1InputValue?: (value: number) => void;
}

const ClosureMsgDailyFrequency = ({
  dailyOption,
  dailyOptoin1InputValue,
  handleDailyOptionsValueChange,
  handleDailyOptoin1InputValue,
}: Props) => {
  const classes = useCss(styles);

  return (
    <SbuxRadioGroup
      value={dailyOption}
      handleRadioButtonChange={handleDailyOptionsValueChange ?? (() => {})}
    >
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Box sx={{ flex: 1, marginLeft: 3 }}>
          <FormControlLabel
            value={"dailyOption1EveryDays"}
            control={<Radio size="small" sx={{ padding: "2px" }} />}
            label={
              <Box
                className={classes.radioFlex}
                sx={{
                  fontSize: 12,
                  pointerEvents:
                    dailyOption !== "dailyOption1EveryDays"
                      ? "none"
                      : undefined,
                  opacity:
                    dailyOption !== "dailyOption1EveryDays" ? 0.6 : undefined,
                }}
              >
                <Box
                  className={classes.radioFlex}
                  sx={{
                    marginRight: 1,
                    fontSize: 12,
                  }}
                >
                  {"Every"}
                </Box>
                <Box className={classes.radioFlex} sx={{ marginRight: 1 }}>
                  <input
                    type={"number"}
                    value={dailyOptoin1InputValue}
                    style={{
                      width: 40,
                      height: 22,
                      fontSize: 12,
                    }}
                    onChange={(event) =>
                      handleDailyOptoin1InputValue?.(Number(event.target.value))
                    }
                  />
                </Box>
                <Box className={classes.radioFlex} sx={{ fontSize: 12 }}>
                  {"day(s)"}
                </Box>
              </Box>
            }
          />
        </Box>
        <Box sx={{ flex: 1, marginLeft: 3 }}>
          <FormControlLabel
            value={"dailyOption2EveryWeekDay"}
            control={<Radio size="small" sx={{ padding: "2px" }} />}
            label={
              <Box
                className={classes.radioFlex}
                sx={{
                  fontSize: 12,
                  marginRight: 1,
                  pointerEvents:
                    dailyOption !== "dailyOption2EveryWeekDay"
                      ? "none"
                      : undefined,
                  opacity:
                    dailyOption !== "dailyOption2EveryWeekDay"
                      ? 0.6
                      : undefined,
                }}
              >
                {"Every Weekday"}
              </Box>
            }
          />
        </Box>
      </Box>
    </SbuxRadioGroup>
  );
};

export default ClosureMsgDailyFrequency;
